import { apiClient } from "../lib/api";

export const mfaApi = {
  setupInit: (setup_token) => apiClient.post("/auth/mfa/setup/init", { setup_token }),
  setupVerify: (setup_token, code) => apiClient.post("/auth/mfa/setup/verify", { setup_token, code }),
  challengeVerify: (challenge_token, code, backup_code) =>
    apiClient.post("/auth/mfa/challenge/verify", { challenge_token, code, backup_code }),
  status: () => apiClient.get("/auth/mfa/status"),
  regenerateBackupCodes: (current_password) =>
    apiClient.post("/auth/mfa/backup-codes/regenerate", { current_password }),
  reset: (user_id, reason) => apiClient.post("/auth/mfa/reset", { user_id, reason }),
};
